import { Component, OnChanges, Input, Output, EventEmitter } from "@angular/core";
import { JqueryExtensionsService } from "../services/jquery.service";
import { StringExtensions } from "../utilities/string.extensions";

export interface IDropdown {
	selected?: number;
	buttonText?: string; /* initial text to be displayed on the button */
	staticButtonText?: boolean; /* keeps the button text the original value after selecting */
	staticSelection?: boolean; /* clears the selection after an item is selected and emitted */
	disabled?: boolean;
}

export interface IDropdownItem {
	text?: string;
	value?: number;
	iconClasses?: string;
	isSeparator?: boolean;
	action?: Function;
	disabled?: boolean;
	flag?: string;
  headerId?: number;
  isExclusive?: boolean;
}

export interface IDropdownHeader {
	headerId?: number;
	text?: string;
}

@Component({
	selector: "dropdown",
	template: `
	<select
		[id]="id"
		[attr.data-size]="rows"
		[attr.data-live-search]="isLiveSearch"
		[title]="model.buttonText === '' ? ' ' : model.buttonText !== undefined ? model.buttonText : ''"
		[attr.data-selected-text-format]="model.staticButtonText ? 'static' : ''"
		[disabled]="!!disabled"
		[(ngModel)]="model.selected"
		(change)="onSelect()"
		class="form-control selectpicker">

		<ng-container *ngIf="headers.length<1">
			<option *ngIf="model.buttonText" data-hidden="true">{{model.buttonText}}</option>
			<option
				*ngFor="let item of dropdownItems"
				[ngValue]="item.value"
				[attr.data-divider]="item.isSeparator"
				[disabled]="!!item.disabled">

				<span *ngIf="item.iconClasses?.length" class="item.iconClasses">
					<span class="{{item.iconClasses}}"></span>
					&nbsp;
				</span>
				<img *ngIf="item.flag?.length" class="flag-xs" src="assets/img/flags/{{item.flag}}.png" />
				{{item.text}}
			</option>
		</ng-container>
		<ng-container *ngIf="headers.length>0">
				<optgroup *ngFor="let header of headers" label="{{header.text}}">
					<ng-container *ngFor="let item of dropdownItems">
						<option *ngIf="header.headerId==item.headerId"
							ngValue="{{item.value}}_{{item.headerId}}"
							[attr.data-divider]="item.isSeparator"
							[disabled]="!!item.disabled">

							<span *ngIf="item.iconClasses?.length" class="item.iconClasses">
								<span class="{{item.iconClasses}}"></span>
								&nbsp;
							</span>
							<img *ngIf="item.flag?.length" class="flag-xs" src="assets/img/flags/{{item.flag}}.png" />
							{{item.text}}
						</option>
					</ng-container>
				</optgroup>
			</ng-container>
	</select>
` })
export class DropdownComponent implements OnChanges {
	@Input() id: string;
	@Input() rows: number;
	@Input() isLiveSearch: boolean;
	@Input() headers: IDropdownHeader[] = [];
	@Input() dropdownItems: IDropdownItem[];
	@Input() model: IDropdown;
	@Input() disabled?: boolean;

	@Output() dropdownChanged: EventEmitter<IDropdownItem> = new EventEmitter<IDropdownItem>();

	constructor(private jqueryService: JqueryExtensionsService) { }

	private refresh() { this.jqueryService.selectpicker("#" + this.id, "refresh"); }

	ngOnChanges() {
		setTimeout(() => {
			this.refresh();
		});
	}

	ngAfterViewInit() {
		setTimeout(() => {
			if (!this.id) { this.id = "dropdown-" + StringExtensions.generateUUID(); }
			setTimeout(() => {
				this.refresh();
			});
		});
	}

	onSelect() {
		let items;
		if (this.headers.length > 0) {
			let selectedValueArray = (this.model.selected || "").toString().split("_");
			if (selectedValueArray.length === 2) {
				items = this.dropdownItems.filter(i => parseInt(selectedValueArray[0], 10) === i.value && parseInt(selectedValueArray[1], 10) === i.headerId);
			}
		} else {
			items = this.dropdownItems.filter(i => this.model.selected === i.value);
		}
		this.dropdownChanged.emit(items && items.length > 0 ? items[0] : undefined);
	}
}
